import Joi from 'joi';
import { STAFF_LIMITS } from './staff-limits';
import { checkStaffPasswordPolicy } from './staff-password-policy';
import { STAFF_ROLES, } from './staff-enums';
const staffEmailSchema = Joi.string().email({ tlds: false }).max(254).lowercase().trim();
/**
 * Kod şeması. Uzunluk `STAFF_LIMITS`ten gelir; ürünün kod uzunluğuyla aynı
 * olması bir tesadüftür, bağ DEĞİLDİR.
 */
const staffCodeSchema = Joi.string()
    .pattern(/^\d+$/)
    .length(STAFF_LIMITS.loginCodeLength)
    .required();
/**
 * Taban/tavan Joi'nin kendi `min`/`max` hatalarını (alan altı cümleleri) verir;
 * `custom` ise politikanın KURAL LİSTESİNİ koşar: listeye kural eklenirse uç da
 * onu doğrular (`staff-password-policy.ts`, elle test B-29).
 */
const staffPasswordSchema = Joi.string()
    .min(STAFF_LIMITS.passwordMinLength)
    .max(STAFF_LIMITS.passwordMaxLength)
    .custom((value, helpers) => {
    // Uzunluk `min`/`max` ile raporlandı: aynı alana ikinci hata yazılmaz (sıra 143b).
    if (value.length < STAFF_LIMITS.passwordMinLength ||
        value.length > STAFF_LIMITS.passwordMaxLength) {
        return value;
    }
    return checkStaffPasswordPolicy(value).ok ? value : helpers.error('any.invalid');
});
export const staffLoginSchema = Joi.object({
    email: staffEmailSchema.required(),
    /*
     * ŞEMA ALTTAN KISITLAMAZ: kısa şifre "en az 12 karakter" hatası alsaydı
     * 400 ≠ 401 ayrımı doğar ve girdi biçiminden bir sinyal üretilirdi.
     * Kısa girdi de yanlış şifredir — tek genel hata.
     */
    password: Joi.string().max(STAFF_LIMITS.passwordMaxLength).required(),
});
export const staffVerifySchema = Joi.object({
    email: staffEmailSchema.required(),
    code: staffCodeSchema,
});
export const staffSetupSchema = Joi.object({
    token: Joi.string().trim().min(16).max(128).required(),
    newPassword: staffPasswordSchema.required(),
});
/**
 * `currentPassword` ZORUNLUDUR (ürün tarafındaki gibi "duruma göre" değil):
 * `staff_accounts.password_hash` NULL olan bir hesabın oturumu HİÇ OLMAZ —
 * oturum ancak şifre + kod ya da davet tüketimiyle doğar. Yani şifresiz bir
 * personel bu uca erişemez ve isteğe bağlı alan bırakmak sahte bir yol açardı.
 */
export const staffChangePasswordSchema = Joi.object({
    currentPassword: Joi.string().max(STAFF_LIMITS.passwordMaxLength).required(),
    newPassword: staffPasswordSchema.required(),
});
export const staffRefreshSchema = Joi.object({});
/**
 * PERSONEL ADRESİNİN ALAN ADI — TEK TÜRETME (S1'den devralınan Düşük).
 *
 * İKİ TÜKETİCİ VARDI VE AYRIŞIYORLARDI: servis `email.lastIndexOf('@')` ile
 * SON `@`den sonrasını alıyordu, dağıtım kapısının SQL'i ise
 * `split_part(email,'@',2)` ile İLK `@`den sonrasını. `a@evil@warmbreak.com`
 * gibi bir adreste servis `warmbreak.com` görüp hesabı AÇAR, kapı `evil` görüp
 * onu İHLAL sayar — yani hesap açılır ve o andan sonra uygulama BAŞLAMAZ.
 * Joi tek `@` dayattığı için pratikte üretilemez; ama iki farklı kural yazmak
 * kapının koruduğu şeyle servisin izin verdiği şeyi ayrıştırır ve bu tek
 * başına kusurdur.
 *
 * KURAL: SON `@`den sonrası, küçük harf. SQL karşılığı
 * `lower(regexp_replace(email, '^.*@', ''))` — açgözlü `.*` son `@`ye kadar
 * yer, yani birebir aynı sonucu verir.
 */
export function staffEmailDomain(email) {
    return email.slice(email.lastIndexOf('@') + 1).toLowerCase();
}
export const createStaffAccountSchema = Joi.object({
    email: staffEmailSchema.required(),
    displayName: Joi.string().trim().min(2).max(120).required(),
    role: Joi.string()
        .valid(...STAFF_ROLES)
        .required(),
});
//# sourceMappingURL=staff-contracts.js.map